import React from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";

const QuizMenu = React.lazy(() => import("@/pages/quiz/QuizMenu"));

const QuizRoutes = [
  {
    path: "quiz",
    element: (
      <SuspenseWrapper>
        <QuizMenu />
      </SuspenseWrapper>
    ),
  },
];

export default QuizRoutes;
